// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2029":"file-upload","2246":"pdf-viewer","8404":"smartdoc"}[chunkId] + "." + {"2029":"a8da1710","2246":"5fbaf402","8404":"909e234a"}[chunkId] + ".chunk.css";
};